import React, { useMemo } from 'react';

/**
 * Renders stored contract HTML with safe wrapping (prevents overflow outside cards).
 */
const ContractBodyHtml = ({ html, className = '' }) => {
  const safeHtml = useMemo(() => {
    if (!html) return '';
    // Soften common Quill / pasted styles that force overflow
    return String(html)
      .replace(/white-space\s*:\s*nowrap/gi, 'white-space:normal')
      .replace(/white-space\s*:\s*pre(?!-)/gi, 'white-space:pre-wrap');
  }, [html]);

  return (
    <>
      <style>{`
        .contract-body-html {
          display: block;
          width: 100%;
          max-width: 100%;
          min-width: 0;
          overflow-x: hidden;
          overflow-wrap: anywhere;
          word-wrap: break-word;
          word-break: break-word;
          white-space: normal;
          box-sizing: border-box;
        }
        .contract-body-html,
        .contract-body-html * {
          max-width: 100% !important;
          box-sizing: border-box;
          overflow-wrap: anywhere !important;
          word-wrap: break-word !important;
          word-break: break-word !important;
        }
        .contract-body-html p,
        .contract-body-html li,
        .contract-body-html div,
        .contract-body-html span,
        .contract-body-html h1,
        .contract-body-html h2,
        .contract-body-html h3,
        .contract-body-html h4,
        .contract-body-html h5,
        .contract-body-html h6 {
          white-space: normal !important;
        }
        .contract-body-html img,
        .contract-body-html video,
        .contract-body-html iframe,
        .contract-body-html table {
          height: auto !important;
        }
        .contract-body-html pre,
        .contract-body-html code {
          white-space: pre-wrap !important;
          overflow-x: auto;
        }
      `}</style>
      <div
        className={`contract-body-html prose prose-sm max-w-none ${className}`}
        dangerouslySetInnerHTML={{ __html: safeHtml }}
      />
    </>
  );
};

export default ContractBodyHtml;
